import {
  WEBINARS_GETTING_STARTED,
  WEBINARS_RUNNING_GROWING
} from '#client/pages/Education/data';

export const BUSINESS_PHASES = {
  GETTING_STARTED: 'getting_started',
  RUNNING_GROWING: 'running_growing'
};

export function useWebinars(businessPhase = BUSINESS_PHASES.GETTING_STARTED) {
  const data = businessPhase === BUSINESS_PHASES.RUNNING_GROWING
    ? WEBINARS_RUNNING_GROWING
    : WEBINARS_GETTING_STARTED;

  return {
    data,
    error: null,
    loading: false,
    refetch: () => {} // No-op since data is static
  };
}
